import { render } from "./CustomOrderContainer.vue?vue&type=template&id=17967340&scoped=true"
import script from "./CustomOrderContainer.vue?vue&type=script&lang=js"
export * from "./CustomOrderContainer.vue?vue&type=script&lang=js"

import "./CustomOrderContainer.vue?vue&type=style&index=0&id=17967340&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17967340"]])

export default __exports__